export type SpacingSize = 'none' | 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

export type SpacingSizeTokens = {
  [S in SpacingSize]: string;
};
export type SpacingTokens = {
  [S in SpacingSize]: { padding: string };
};

const sizeValues: {
  [S in SpacingSize]: number;
} = {
  none: 0,
  xxs: 0.125,
  xs: 0.25,
  s: 0.5,
  m: 1,
  l: 1.5,
  xl: 2,
  xxl: 2.5,
};

const sizeNames = Object.keys(sizeValues) as SpacingSize[];

// Create the core size tokens
const core = sizeNames.reduce((sizeTokens, size) => {
  sizeTokens[size] = `${sizeValues[size]}rem`;
  return sizeTokens;
}, {} as SpacingSizeTokens);

// Create the block tokens
const block = sizeNames.reduce((sizeTokens, size) => {
  sizeTokens[size] = `${sizeValues[size]}rem`;
  return sizeTokens;
}, {} as SpacingSizeTokens);

// Create the inline tokens
const inline = sizeNames.reduce((sizeTokens, size) => {
  sizeTokens[size] = `${sizeValues[size]}rem`;
  return sizeTokens;
}, {} as SpacingSizeTokens);

// Create the inset-squish tokens
const insetSquish = sizeNames.reduce((spacingTokens, size) => {
  spacingTokens[size] = { padding: `${0.5 * sizeValues[size]}rem ${core[size]}` };
  return spacingTokens;
}, {} as SpacingTokens);

// Create the inset-stretch tokens
const insetStretch = sizeNames.reduce((spacingTokens, size) => {
  spacingTokens[size] = { padding: `${core[size]} ${0.5 * sizeValues[size]}rem` };
  return spacingTokens;
}, {} as SpacingTokens);

export const spacing: {
  core: SpacingSizeTokens;
  block: SpacingSizeTokens;
  inline: SpacingSizeTokens;
  insetSquish: SpacingTokens;
  insetStretch: SpacingTokens;
  size: SpacingSizeTokens;
} = {
  core,
  block,
  inline,
  insetSquish,
  insetStretch,
  size: {
    none: '0',
    xxs: '96px',
    xs: '192px',
    s: '240px',
    m: '320px',
    l: '400px',
    xl: '640px',
    xxl: '960px',
  },
};
